import { HomeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { AppBar } from '@horof/shared';
import type { ReactNode } from 'react';
import {
  createBrowserRouter,
  Navigate,
  NavLink,
  Outlet,
  ScrollRestoration,
} from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { BankPage } from './BankPage';
import { HomePage } from './HomePage';
import { HELP } from './help';
import { NewOperationPage, OperationPage } from './OperationPages';
import { OperationsPage } from './OperationsPage';

/** Two places only (doc 38): the rest is done on the desk. */
const SECTIONS: { to: string; label: string; icon: ReactNode }[] = [
  { to: '/', label: 'الرئيسية', icon: <HomeOutlined /> },
  { to: '/operations', label: 'العمليات', icon: <UnorderedListOutlined /> },
];

function Layout() {
  return (
    <>
      <ScrollRestoration />
      <AppBar help={HELP} />
      <div className="with-nav">
        <Outlet />
      </div>
      <nav className="bottom-nav">
        {SECTIONS.map((s) => (
          <NavLink key={s.to} to={s.to} end={s.to === '/'}>
            {s.icon}
            <span>{s.label}</span>
          </NavLink>
        ))}
      </nav>
    </>
  );
}

const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { path: '/', element: <HomePage /> },
        { path: '/new/:type', element: <NewOperationPage /> },
        { path: '/bank', element: <BankPage /> },
        { path: '/operations', element: <OperationsPage /> },
        { path: '/operations/:operationId', element: <OperationPage /> },
        // Screens moved to the desk (transfers, loans, lists…): home.
        { path: '*', element: <Navigate to="/" replace /> },
      ],
    },
  ],
  { basename: import.meta.env.BASE_URL },
);

export function App() {
  return <RouterProvider router={router} />;
}
